import { render, staticRenderFns } from "./archived_badge.vue.js?vue&type=template&id=9f1d0fae&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./archived_badge.vue?vue&type=template&id=9f1d0fae&vue3"
import script from "./archived_badge.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./archived_badge.vue?vue&type=script&lang=js&vue3"
export * from "./archived_badge.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./archived_badge.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports